export default {"src":"/_next/static/media/business-banner.d05a2869.svg","height":386,"width":667,"blurWidth":0,"blurHeight":0};